import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { IChangeLogEntry, IErrorLogEntry } from './audit-log.types';
import { NotificationsService } from 'app/notifications/notifications.service';
import { map, mergeMap } from 'rxjs/operators';
import * as moment from 'moment-timezone';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.scss']
})
export class AuditLogComponent implements OnInit {
  constructor(private route: ActivatedRoute, private notificationsService: NotificationsService) { }
  changeLogDataSource: any = new MatTableDataSource<IChangeLogEntry>();
  changeLogColumns: string[] = ['record', 'crewMember', 'dataPoint', 'original', 'arrow', 'replacement'];
  @ViewChild('sortChanges', { static: false }) sortChanges: MatSort;

  // Error Log Grid
  errorLogDataSource: any = new MatTableDataSource<IErrorLogEntry>();
  errorLogColumns: string[] = ['logType', 'record'];
  @ViewChild('sortErrors', { static: false }) sortErrors: MatSort;

  selectedNotification: any;
  importedDate: string = '';
  importedTime: string = '';

  ngOnInit(): void {
    this.extractParamsAndLoadData();
  }

  // Filter methods for search functionality
  public applyChangeLogFilter(event: Event): void {
    const filterValue: any = (event.target as HTMLInputElement).value;
    this.changeLogDataSource.filter = filterValue.trim().toLowerCase();
  }

  // Filter methods for search functionality
  public applyErrorLogFilter(event: Event): void {
    const filterValue: any = (event.target as HTMLInputElement).value;
    this.errorLogDataSource.filter = filterValue.trim().toLowerCase();
  }

  private extractParamsAndLoadData(): void {
    this.route.params
      .pipe(
        mergeMap(param => {
          return this.route.queryParams.pipe(
            map(queryParam => {
              return { ...queryParam, ...param };
            })
          );
        })
      )
      .subscribe(response => {
        const utcDate: moment.Moment = moment.utc(response.date);
        this.importedDate = utcDate.tz('America/New_York').format('Do of MMMM YYYY');
        this.importedTime = utcDate.tz('America/New_York').format('hh:mm a');
        this.getAuditLogData(response.importId);
      });
  }

  private getAuditLogData(importId: string): void {
    this.notificationsService.getAuditLogData(importId).subscribe(data => {
      this.changeLogDataSource.data = data.changeLogs;
      this.errorLogDataSource.data = data.errorLogs;
      setTimeout(() => {
        if (this.sortChanges) {
          this.changeLogDataSource.sort = this.sortChanges;
        }
        if (this.sortErrors) {
          this.errorLogDataSource.sort = this.sortErrors;
        }
      }, 0);
    });
  }
}
